import { render, staticRenderFns } from "./RelationshipEditorDialog.vue?vue&type=template&id=36eafab6&scoped=true"
import script from "./RelationshipEditorDialog.vue?vue&type=script&lang=js"
export * from "./RelationshipEditorDialog.vue?vue&type=script&lang=js"
import style0 from "./RelationshipEditorDialog.vue?vue&type=style&index=0&id=36eafab6&prod&lang=scss&scoped=true"
import style1 from "./RelationshipEditorDialog.vue?vue&type=style&index=1&id=36eafab6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36eafab6",
  null
  
)

export default component.exports